import {add, bignumber, BigNumber, multiply} from "mathjs";
import {divide} from "./api-mpms";
import {TemperatureUnit, TemperatureUnitCelsius, TemperatureUnitFahrenheit,} from "./unit/temperature-unit";
import {UnitValue} from "./unit/unit";

export class Temperature extends UnitValue<TemperatureUnit> {

  to(unit: TemperatureUnit): Temperature {
    if (unit === TemperatureUnitFahrenheit) {
      const convertedValue = Temperature.convertToFahrenheit(this)
      return new Temperature(convertedValue, unit)
    } else if (unit === TemperatureUnitCelsius) {
      const convertedValue = Temperature.convertToCelsius(this)
      return new Temperature(convertedValue, unit)
    } else {
      throw new Error("Unknown unit: " + unit);
    }
  }

  rounded(): Temperature {
    const roundedValue = this.roundedValue()
    return new Temperature(roundedValue, this.unit)
  }

  static convertToFahrenheit(temperature: Temperature): BigNumber {
    if (temperature.unit === TemperatureUnitFahrenheit) {
      return temperature.value
    } else if (temperature.unit === TemperatureUnitCelsius) {
      return add(
        multiply(
          bignumber("1.8"),
          temperature.value
        ),
        bignumber("32")
      ) as BigNumber
    } else {
      throw new Error("Unknown unit: " + temperature.unit)
    }
  }

  static convertToCelsius(temperature: Temperature): BigNumber {
    if (temperature.unit === TemperatureUnitCelsius) {
      return temperature.value
    } else if (temperature.unit === TemperatureUnitFahrenheit) {
      return divide(temperature.value.minus(bignumber(32)), bignumber("1.8"));
    } else {
      throw new Error("Unknown unit: " + temperature.unit)
    }
  }
}
